import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import MobileFooter from 'bento-ordering/base/components/MobileFooter';
import CartPageCheckoutContainer from 'bento-ordering/cart/containers/CartPageCheckoutContainer';
import { selectHasCartItems } from 'bento-ordering/cart/selectors/selectHasCartItems';
import { useIsGroupOrderGuestDiner } from 'bento-ordering/group_ordering/hooks/index';
import GroupOrderDinerFooter from 'bento-ordering/group_ordering/components/GroupOrderDinerFooter';

function CartPageFooter({ toggleIsOpen }) {
  const hasCartItems = useSelector(selectHasCartItems);
  const isGroupOrderGuestDiner = useIsGroupOrderGuestDiner();

  if (!hasCartItems) {
    return null;
  }

  return (
    <MobileFooter>
      {isGroupOrderGuestDiner ? (
        <GroupOrderDinerFooter />
      ) : (
        <CartPageCheckoutContainer
          dataTestId="mobile-checkout-button"
          toggleIsOpen={toggleIsOpen}
        />
      )}
    </MobileFooter>
  );
}

CartPageFooter.propTypes = {
  toggleIsOpen: PropTypes.func.isRequired
};

export default CartPageFooter;
